import Vue from 'vue'
import vueKanban from 'vue-kanban'


Vue.use(vueKanban)
